import Axios from 'axios'

const documentLaboratory = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },

  uploadDocumentExam(document) {
    let hasOsNumber = document.osNumber ? '/' + document.osNumber : ''
    let formData = new FormData()
    formData.append('name', document.file)

    return this.axios().post('/order/upload-exam-document' + hasOsNumber, formData, {
      params: {
        id_exam_order: document.idExamOrder,
        id_document_template_exam: document.idDocumentTemplateExam,
        file_name_document_template: document.fileName
      }
    })
  },
  deleteDocumentUploaded(idExam, osNumber) {
    let hasOsNumber = osNumber ? '/' + osNumber : ''
    return this.axios().delete('/order/document-exam-upload/' + idExam + hasOsNumber)
  },
  downloadDocument(idExam) {
    return this.axios().get('/exam/document/' + idExam, {})
  }
}

export default documentLaboratory
